// this needs to coexist along drop2.direcive.ts until every component using ClDropDirective is migrated from angularJS
export class ClDropDirective implements angular.IDirective {
    public static $name: string = 'clDropElement';
    public restrict: string = 'A';

    public scope: any = {
        clDrop: '&',
        clLeave: '&',
        clOver: '&'
    };

    public link = (scope: angular.IScope | any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        const ele = element[0];

        const dragStop = event => {
            scope.clDrop({ event: event });
        };

        const dragOver = event => {
            scope.clOver({ event: event });
        };

        const dragLeave = event => {
            scope.clLeave({ event: event });
        };

        ele.addEventListener('drop', dragStop);
        ele.addEventListener('dragover', dragOver);
        ele.addEventListener('dragleave', dragLeave);

        scope.$on('$destroy', () => {
            ele.removeEventListener('drop', dragStop);
            ele.removeEventListener('dragover', dragOver);
            ele.removeEventListener('dragleave', dragLeave);
        });
    }

    public static Factory() {
        const directive = () => {
            return new ClDropDirective();
        };

        return directive;
    }
}
